import { Netmask } from 'netmask';
import { HintText } from '#components/atoms/forms/index.ts';

// We do not assign hosts to the base network address or broadcast address
const RESERVED_IP_ADDRESS_COUNT = 2;

type Props = {
  cidr?: string;
  className?: string;
  reservedAddressCount?: number;
};

export function NetworkSize({ cidr = '', className, reservedAddressCount = RESERVED_IP_ADDRESS_COUNT }: Props) {
  let netmask: Netmask;
  let addressCount: number;

  try {
    netmask = new Netmask(cidr);

    if (!netmask.size) return null;

    addressCount = netmask.size - reservedAddressCount;
  } catch {
    /* invalid cidr, so don't return element */
    return null;
  }

  return (
    <HintText className={className}>
      {addressCount === 1 ?
        `1 address (${netmask.first})`
      : `${addressCount.toLocaleString()} addresses (${netmask.first} to ${netmask.last})`}
    </HintText>
  );
}
